import {React, useEffect} from 'react';
import { useParams, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import testimonial from '../images/liaison/testimonial.png'
import slider_CTA from '../images/liaison/Slider_CTA.png'
import testimonial_icon from '../images/Components/Testimonial_icon.png'

function Testimonial () {

    const path = useLocation();
    console.log(path);
    const route = path.pathname.slice(1);
    console.log(route);

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])

    testimonial = [
        {
            content:"I am writing to extend my heartfelt congratulations on obtaining statutory approval for our Coimbatore project. This was certainly not the easiest one & a significant milestone.",
            name: "Sunil Shete",
            service: "Liaison Service",
        },
        {
            content:"I approached Lands and Lands through one of my friends to apply for a patta for a plot in Coimbatore. After a very reasonable waiting time, I got the patta. Their service was very professional.",
            name: "Mathivanan Devadoss",
            service: "Name Transfer Service",
        },
        {
            content: "Lands and Lands coordinated the sale and registration of my flat. They were very patient, approachable & responsive. The whole deal was completed through messages and phone calls as I am staying in another city.",
            name: "Venugopal CS",
            service:"Property Brokerage Service",
        },
    ]

    return (
    <>
        {/* Testimonial */}
        {/* <div className="bg-grey">
            <div className="max-w-[1125px] mx-auto flex flex-wrap justify-between px-6 py-14 sm:pt-[201px] sm:pb-[169px]" data-aos="fade-up">
                <img className="sm:w-[590px] sm:h-[406px] mx-auto" src={testimonial} alt="testimonial" />
                <div className="max-w-[410px] my-auto mx-auto">
                    <p className="text-[#545857] font-[karma] text-[21.3px] leading-[26px] tracking-[0.5px] font-semibold  mt-10 lg:mt-6">Lorem ipsum dolor sit amet consectetur. Nulla imperdiet ut non in quis faucibus lacus. Aliquam sed sed id vehicula. Sit neque tellus felis dignissim condimentum pellentesque nunc nisl.</p>
                    
                    <div className="text-[20px] leading-[24.10px] tracking-[-0.202px] mt-8" data-aos="fade-up" data-aos-duration="500">
                        <h3 className=" font-[lato] font-semibold uppercase py-0.5 text-[17px] tracking-[0.3px]">Krishnasamy g.</h3>
                        <p className="text-[18px] font-normal">Coimbatore</p>
                        <img className="w-[64px] h-[47px] mt-[50px] font-[Lato]" src={slider_CTA} alt="Cta" data-aos="fade-up" data-aos-duration="600" />
                    </div>
                </div>
            </div>
        </div> */}

        <div className='max-w-[1236px] mx-auto bg-[#F6F6F6] lg:h-[421px] lg:mb-[300px] py-10 my-20' data-aos="fade-up" data-aos-duration="1000">
            <h2 className='subheading py-16 md:py-20'>What our clients <br className='block md:hidden' /> say about us..</h2>

            <div className='flex flex-wrap mt-12 justify-evenly gap-y-12' data-aos="fade-up" data-aos-duration="1000">
                {
                    testimonial.map((items)=>{
                    return(
                        <div className='relative w-[321px] h-[385px] bg-white border border-[#E0E0E0] rounded-[8px] shadow-md px-6 pt-14'>
                            <img className='absolute w-[38px] -top-3 left-5 ' src={testimonial_icon} alt='Testimonial_icon' />
                            <p className='paragraph !leading-[30px]'>{items.content}</p>
                    
                            <div className='font-[lato] absolute bottom-7'>
                                <hr className='text-[#D9D9D9] border-[2px] w-[42px] mb-4' />
                                <h2 className='text-[#17212B] text-[18px] font-[700] leading-[25px]'>{items.name}</h2>
                                <p className='text-[#575857]'>{items.service}</p>
                            </div>  
                        </div>

                    )})
                }
            </div>

        </div>

    </>
    );
}

export default Testimonial;